// @flow
const fonts = {
  primary: 'ff-market-web',
  secondary: 'Times'
}

const colors = {
  orangePeel: '#FFA000',
  blueWhale: '#03344A',
  darkBlue: '#04133d',
  gray: '#8F8F8F',
  cararra: '#EFF0EA',
  white: '#FFFFFF'
}

export { fonts, colors }



// WEBPACK FOOTER //
// ./src/styles/styleGuide.js